var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "withdrawal_management" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("订单管理")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "search_criteria",
          staticStyle: {
            "margin-top": "10px",
            background: "#fff",
            padding: "20px",
            "border-radius": "8px",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-left": "0" } },
            [
              _c("el-input", {
                attrs: { placeholder: "输入订单编号查询", clearable: "" },
                model: {
                  value: _vm.queryData.orderNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "orderNo", $$v)
                  },
                  expression: "queryData.orderNo",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("el-input", {
                attrs: { placeholder: "输入商品名称查询", clearable: "" },
                model: {
                  value: _vm.queryData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "title", $$v)
                  },
                  expression: "queryData.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("el-input", {
                attrs: { placeholder: "输入商品ID查询", clearable: "" },
                model: {
                  value: _vm.queryData.goodsId,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "goodsId", $$v)
                  },
                  expression: "queryData.goodsId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("el-input", {
                attrs: { placeholder: "输入用户ID查询", clearable: "" },
                model: {
                  value: _vm.queryData.memberId,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "memberId", $$v)
                  },
                  expression: "queryData.memberId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "选择商品平台类型", clearable: "" },
                  model: {
                    value: _vm.queryData.platformCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "platformCode", $$v)
                    },
                    expression: "queryData.platformCode",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "TB", label: "淘宝" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { value: "JD", label: "京东" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { value: "PDD", label: "拼多多" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "选择所属活动",
                  },
                  model: {
                    value: _vm.queryData.activityId,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "activityId", $$v)
                    },
                    expression: "queryData.activityId",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.activityName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "选择订单状态", clearable: "" },
                  model: {
                    value: _vm.queryData.orderStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "orderStatus", $$v)
                    },
                    expression: "queryData.orderStatus",
                  },
                },
                [
                  _c("el-option", { attrs: { value: 1, label: "已支付" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { value: 2, label: "已取消" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { value: 3, label: "已结算" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { value: 4, label: "已收货" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex",
              staticStyle: { width: "fit-content", height: "40px" },
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { height: "40px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.onInquire },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "ml10",
                  staticStyle: { height: "40px" },
                  attrs: { type: "info", plain: "" },
                  on: { click: _vm.onInitialize },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "mt20",
            staticStyle: {
              background: "#fff",
              padding: "20px",
              "border-radius": "8px",
            },
          },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.tableData,
                  "tooltip-effect": "dark",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "withdrawNo", label: "会员", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "pointer",
                              staticStyle: {
                                "font-size": "14px",
                                color: "#4d8aff",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onUserDetails(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.nickname) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v("uid:" + _vm._s(scope.row.memberId)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "orderNo",
                    label: "订单编号",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "商品信息", align: "center", width: "500" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-start",
                                "font-size": "12px",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  display: "block",
                                  width: "80px",
                                  height: "80px",
                                },
                                attrs: { src: scope.row.goodsPic },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "5px" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ellipsis-multiline",
                                      staticStyle: { "text-align": "left" },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "20px",
                                          height: "20px",
                                          "vertical-align": "middle",
                                        },
                                        attrs: {
                                          alt: "",
                                          src: _vm.picObj[
                                            scope.row.platformCode
                                          ],
                                        },
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(scope.row.title) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "11px",
                                        "text-align": "left",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  商品ID:" +
                                          _vm._s(scope.row.goodsId) +
                                          "\n                  "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            background: "#F4F4F5",
                                            color: "#797979",
                                            border: "1px solid #909399",
                                            padding: "1px 3px",
                                            "margin-left": "3px",
                                            cursor: "pointer",
                                            "border-radius": "5px",
                                            "font-size": "9px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copy(scope.row.goodsId)
                                            },
                                          },
                                        },
                                        [_vm._v("复制")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "\n                    券后价："
                                        ),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(scope.row.couponPrice)
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "40px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    原价："
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "text-decoration":
                                                  "line-through",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "￥" +
                                                  _vm._s(scope.row.originPrice)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "payAmt", label: "支付金额", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "giftAmt",
                    label: "礼金金额",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "commission", label: "佣金", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "selfOrderCount",
                    label: "商品平台类型",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.platformMapping[scope.row.platformCode]
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "activityName",
                    label: "所属活动",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "userTypeName",
                    label: "用户类型",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "orderStatusName",
                    label: "状态",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: "创建时间",
                    align: "center",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt20 page_box" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.queryData.page,
                    "page-sizes": [10, 20, 30, 40],
                    "page-size": _vm.queryData.size,
                    layout: "total, prev, pager, next, sizes,jumper",
                    total: _vm.total,
                    background: "",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }